<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Location Name *"
                      v-model="formSchema.location_name"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-btn
                      class="success"
                      flat
                      v-if="userRole.saveButton || userRole.updateButton"
                      @click.native="validateBeforeSubmit"
                    >
                      <v-icon>save</v-icon>
                      {{ buttonTitle }}
                    </v-btn>
                    
                    <v-btn
                      class="info"
                      flat
                      @click.native="close({message:'Form Reseted !',status:1})"
                    >
                      <v-icon>refresh</v-icon>Reset
                    </v-btn>
                    
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Asset Location"
        : "Add Asset Location";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_location")
            .then(res => {
              this.close(res);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "asset_location")
            .then(res => {
              this.close(res);
            });
        }
      }
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/asset/asset_location/asset_location_form.vue